<script>
    import {uuid} from '../../Database.svelte';

    export let value;
    export let disabled = false;;

    function addTag(evt) {
        let textBox = evt.target.tag;
        let colorClass = evt.target.color_class;

        let tag = {
            id: uuid(),
            name: textBox.value,
            color_class: colorClass.value
        }

        value = [...value, tag];

        textBox.value = '';
    }

    function deleteTag(tag) {
        value = value.filter(t => t.id != tag.id);
    }
</script>

<div class="fields content">
    {#each value as tag (tag.id)}
        <div class="field has-addons">
            <p class="control">
                <button class="button is-{tag.color_class || 'info'}" >{tag.name}</button>
            </p>
            {#if !disabled}
                <p class="control">
                    <button class="button is-light" on:click={() => deleteTag(tag)}>
                        X
                    </button>
                </p>
            {/if}
        </div>
    {/each}
</div>
{#if !disabled}
    <form on:submit|preventDefault={addTag}>
        <div class="field has-addons">
            <p class="control">
                <span class="select">
                    <select name="color_class">
                        <option value="info">Blue</option>
                        <option value="success">Green</option>
                        <option value="warning">Yellow</option>
                        <option value="danger">Red</option>
                    </select>
                </span>
            </p>
            <div class="control">
                <input class="input" name="tag" type="text" placeholder="Tag" required>
            </div>
            <div class="control">
                <button class="button is-info">
                    Add Tag
                </button>
            </div>
        </div>
    </form>
{/if}

<style>
    .fields {
        display: flex;
        gap: 0.75rem;
        flex-wrap: wrap;
        margin-top: .75rem;
    }
</style>